import { createActionCreator } from "common/ReduxUtils";
import { InboundActionTypes } from "inbounds/store/InboundActionTypes";

export const setHasInactiveLabels = createActionCreator<boolean>(
  InboundActionTypes.SET_HAS_INACTIVE_LABELS,
  "hasInactiveLabels"
);
